import Joi from '@hapi/joi'

export const RubberCollectionObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    estateID: Joi.number().required().label("Estate Name").messages({
        "any.invalid": `Estate Name cannot have invalid characters`,
        "any.required": `Estate Name characters`
    }),
    divisionID: Joi.number().required().label("Division Name").messages({
        "any.invalid": `Division Name cannot have invalid characters`,
        "any.required": `Division Name Type characters`
    }),
    fieldID: Joi.number().required().label("Feild Name").messages({
        "any.invalid": `Feild Name cannot have invalid characters`,
        "any.required": `Feild Name Type characters`
    }),
    searchDate: Joi.string().invalid("").label("Search Date"),
    sessionID: Joi.string().label("Session")
}